import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Colors from '../../colors';
import SimpleRowCard from '../SimpleRowCard';
import MemberInfoModal from '../modals/MemberInfoModal';
import CheckInConfirmationModal from '../modals/SignInConfirmationModal';
import { Divider } from '@mui/material';

function MembersList({ member, updateMember, deleteMemberDB, isArchived }) {
  const { firstName, lastName, checkinTime, checkoutTime, checkin, checkout, phoneNumber, notes, equipment } = member;
  const [isChecked, setIsChecked] = useState(false)
  const [checkboxColor, setCheckboxColor] = useState(Colors.green)
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  useEffect(() => {
    if (checkin) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
    if (checkout) {
      setCheckboxColor(Colors.orange);
    } else {
      setCheckboxColor(Colors.green)
    }
    // eslint-disable-next-line
  }, [member]);

  const handleOpen = () => setOpen(true);
  const handleOpen1 = () => setOpen1(true);

  const handleCheckIn = () => {
    setIsChecked(true)
    const now = new Date();
    const updatedMember = { ...member, checkin: true, checkinTime: now.toLocaleTimeString() };
    updateMember(updatedMember);
    setOpen1(false);
  };

  const handleUnCheckIn = () => {
    setIsChecked(false)
    const updatedMember = { ...member, checkin: false, checkinTime: null };
    updateMember(updatedMember);
    setOpen1(false);
  };

  const handleCheckOut = () => {
    setCheckboxColor(Colors.orange)
    const now = new Date();
    const updatedMember = { ...member, checkout: true, checkoutTime: now.toLocaleTimeString() };
    updateMember(updatedMember);
    setOpen1(false);
  };

  const handleUnCheckOut = () => {
    setCheckboxColor(Colors.green)
    const updatedMember = { ...member, checkout: false, checkoutTime: null };
    updateMember(updatedMember);
    setOpen1(false);
  };

  const saveButtonOnClickHandler = (phoneNumber, equipment, notes) => {
    const updatedMember = {
      ...member,
      phoneNumber: phoneNumber.trim(),
      notes: notes.trim(),
      equipment: equipment.trim()
    };
    updateMember(updatedMember);
  };

  const deleteMemberHandler = () => {
    deleteMemberDB(member)
    setOpen(false)
  };

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!member.checkin) {
      handleCheckIn()
    } else {
      setOpen1(true)
    }
  };

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <SimpleRowCard
        disabled={isArchived}
        icon={
          <FormControlLabel
            control={
              <Checkbox
                disabled={isArchived}
                icon={<CircleOutlinedIcon sx={{ color: Colors.green, fontSize: 34 }} />}
                checkedIcon={<CheckCircleOutlineOutlinedIcon sx={{ backgroundColor: checkboxColor, color: 'white', borderRadius: '50%', fontSize: 32 }} />}
                name={`${firstName} ${lastName}`}
                checked={isChecked}
                onClick={handleCheckboxClick}
              />
            }
            onClick={handleOpen1}
          />}
        label={
          <div style={{ width: '100%' }}>
            <Typography style={{ fontWeight: 500, fontFamily: 'Jost', fontSize: '1.15rem' }}>{`${firstName} ${lastName}`}</Typography>
            <Divider />
            {equipment !== '' && <Typography component="p" sx={{ color: Colors.mediumGray2, fontFamily: 'Jost' }}>
              <Typography component="span" sx={{ fontWeight: 600, color: Colors.mediumGray2, fontFamily: 'Jost' }}>{'Equipment: '}</Typography>
              {equipment}
            </Typography>}
          </div>
        } onClick={handleOpen}>

      </SimpleRowCard>

      {!isArchived && open1 && <CheckInConfirmationModal
        firstName={firstName}
        lastName={lastName}
        open={open1}
        checkin={checkin}
        checkout={checkout}
        setOpen={setOpen1}
        handleCheckIn={handleCheckIn}
        handleCheckOut={handleCheckOut}
        handleUnCheckIn={handleUnCheckIn}
        handleUnCheckOut={handleUnCheckOut} />}
      {open && <MemberInfoModal
        firstName={firstName}
        lastName={lastName}
        checkinTime={checkinTime}
        checkoutTime={checkoutTime}
        isVisible={open}
        setIsVisible={setOpen}
        phoneNumber={phoneNumber}
        notes={notes}
        equipment={equipment}
        onClick={saveButtonOnClickHandler}
        deleteMemberHandler={deleteMemberHandler}
        isArchived={isArchived} />}
    </div>
  );
}

export default MembersList;
